/* ============================================================
   PLUSHIE PATCH — homepage interactions
   Product data is injected by the bestsellers section as
   window.PP_PRODUCTS (real Shopify data). All widgets read it.
   ============================================================ */
(function () {
  "use strict";
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var products = window.PP_PRODUCTS || [];

    /* ---------- toast ---------- */
    var tt;
    function toast(m) {
      var t = document.getElementById('toast');
      if (!t) return;
      t.textContent = m; t.classList.add('show');
      clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('show'); }, 2600);
    }
    window.toast = toast;

    /* ---------- real Shopify add to cart ---------- */
    function addToCart(variantId, name) {
      if (!variantId) { toast('Pick options on the product page 🧸'); return; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        var c = document.querySelector('.cart-wrap');
        if (c) { c.style.transform = 'scale(1.2)'; setTimeout(function () { c.style.transform = ''; }, 180); }
        toast('Added — ' + String(name || '').split('—')[0].trim() + ' 🧸');
      })
      .catch(function () { toast('Hmm, try the product page 🧸'); });
    }
    window.addToCart = addToCart;
    window.notifyMe = function (b) { b.textContent = "✓ We'll email you!"; toast("You're on the restock list 💌"); };

    /* ---------- render bestsellers grid ---------- */
    var grid = document.getElementById('grid');
    if (grid && products.length) {
      grid.innerHTML = products.map(function (p, idx) {
        var badge = p.soldout
          ? '<span class="tag soft">Back soon</span>'
          : (p.tag ? '<span class="tag">' + p.tag + '</span>' : '');
        var was = p.compareStr ? '<span class="was">' + p.compareStr + '</span>' : '';
        var btn = p.soldout
          ? '<button class="add notify" onclick="notifyMe(this)">🔔 Notify me</button>'
          : '<button class="add" onclick="addToCart(' + (p.id || 'null') + ', ' + JSON.stringify(p.name) + ')">Add to cart</button>';
        return '' +
          '<article class="card">' +
            '<div class="imgbox" onclick="openStory(' + idx + ')" title="Tap me — I have something to tell you!">' +
              badge + '<span class="tap-hint">tap me! 💬</span>' +
              '<img src="' + p.img + '" alt="' + (p.name || '').replace(/"/g, '&quot;') + '" loading="lazy">' +
            '</div>' +
            '<div class="body">' +
              '<div class="stars">' + p.rating + (p.reviews ? '<span>(' + p.reviews + ')</span>' : '') + '</div>' +
              '<h3><a href="' + p.url + '" style="color:inherit">' + p.name + '</a></h3>' +
              '<div class="price"><span class="now">' + p.priceStr + '</span>' + was + '</div>' +
              btn +
            '</div>' +
          '</article>';
      }).join('');
    }

    /* ---------- jump-out story popup ---------- */
    window.openStory = function (i) {
      var p = products[i]; if (!p) return;
      var modal = document.getElementById('storyModal');
      var plush = document.getElementById('storyPlush');
      plush.style.animation = 'none'; void plush.offsetWidth; plush.style.animation = '';
      plush.src = p.img; plush.alt = p.name;
      document.getElementById('storyName').textContent = p.short;
      document.getElementById('storyText').textContent = '\u201C' + p.story + '\u201D';
      var addBtn = document.getElementById('storyAdd');
      if (p.soldout) {
        addBtn.textContent = '🔔 Notify me';
        addBtn.onclick = function () { closeStory(); toast("You're on the restock list 💌"); };
      } else {
        addBtn.textContent = 'Take me home 🏡';
        addBtn.onclick = function () { addToCart(p.id, p.name); closeStory(); };
      }
      modal.classList.add('show');
    };
    function closeStory() { var m = document.getElementById('storyModal'); if (m) m.classList.remove('show'); }
    window.closeStory = closeStory;

    /* ---------- brand story scroll reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
      }, { threshold: .3 });
      document.querySelectorAll('.chapter').forEach(function (c) { io.observe(c); });
    } else {
      document.querySelectorAll('.chapter').forEach(function (c) { c.classList.add('in'); });
    }

    /* ---------- storyteller narration ---------- */
    var tale = [
      "Once upon a patch, one person and one laptop set out to make the world a little softer… 🧸",
      "We picked only the plushies we'd give our own family — soft, safe, and a little bit magical. ✨",
      "Then our very first order arrived. We may have happy-danced around the whole room! 🎉",
      "First customers, first reviews, our first wobbly little reel… snuggle by snuggle, the patch grew. 💗",
      "We're not perfect — just human. A real person reads every message and truly cares. 🤍",
      "And so the story keeps going… from our patch, all the way to your home. 💖"
    ];
    var taleStep = 0;
    function renderTale() {
      var tt = document.getElementById('taleText'); if (!tt) return;
      tt.innerHTML = '<span>' + tale[taleStep] + '</span>';
      document.getElementById('taleDots').innerHTML = tale.map(function (_, i) { return '<i class="' + (i === taleStep ? 'on' : '') + '"></i>'; }).join('');
      var last = taleStep === tale.length - 1;
      var about = window.PP_ABOUT_URL || '/';
      document.getElementById('taleActions').innerHTML = last
        ? '<a href="' + about + '" class="btn">Read the full tale 📖</a><button class="btn ghost" onclick="closeTale()">The end 💖</button>'
        : '<button class="btn ghost" onclick="closeTale()">Skip</button><button class="btn" onclick="nextTale()">Next →</button>';
    }
    window.startTale = function () { taleStep = 0; renderTale(); var m = document.getElementById('taleModal'); if (m) m.classList.add('show'); };
    window.nextTale = function () { if (taleStep < tale.length - 1) { taleStep++; renderTale(); } };
    window.closeTale = function () { var m = document.getElementById('taleModal'); if (m) m.classList.remove('show'); };

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeStory(); window.closeTale(); } });

    /* ---------- pros / cons widget ---------- */
    var pcData = {
      "Breathing plushies": {
        pro: ["Gentle rise-and-fall motion that genuinely soothes kids to sleep", "Soft glow + lullaby modes double as a night light", "Super soft, kid-safe materials", "USB rechargeable — no constant battery buying"],
        con: ["Needs charging before bedtime use", "Motor makes a faint hum (most kids find it calming)", "Ships from our partner warehouse, so allow a few extra days"]
      },
      "Comfort plushies": {
        pro: ["Big, huggable, and weighted-soft for cuddles", "No batteries or charging — love it forever", "Great for anxiety, travel, and big feelings", "Easy to spot-clean"],
        con: ["Surface-wash only (not machine-safe)", "Colors may vary slightly from screen to screen"]
      },
      "Night lights": {
        pro: ["Warm, adjustable glow that's easy on little eyes", "Auto-timer so it won't run all night", "Doubles as a cute room decoration", "Low energy use"],
        con: ["Best as a soft accent light, not a main room light", "Wall adapter sold separately on some models"]
      }
    };
    var pcSelect = document.getElementById('pcSelect');
    if (pcSelect) {
      var proList = document.getElementById('proList'), conList = document.getElementById('conList');
      var keys = Object.keys(pcData);
      pcSelect.innerHTML = keys.map(function (k, i) { return '<button class="pc-pill' + (i === 0 ? ' active' : '') + '" onclick="setPC(\'' + k + '\',this)">' + k + '</button>'; }).join('');
      window.setPC = function (k, btn) {
        document.querySelectorAll('.pc-pill').forEach(function (p) { p.classList.remove('active'); });
        if (btn) btn.classList.add('active');
        proList.innerHTML = pcData[k].pro.map(function (x) { return '<li><span class="mk">✓</span>' + x + '</li>'; }).join('');
        conList.innerHTML = pcData[k].con.map(function (x) { return '<li><span class="mk">!</span>' + x + '</li>'; }).join('');
      };
      window.setPC(keys[0]);
    }

    /* ---------- order tracking ---------- */
    window.trackOrder = function () {
      var input = document.getElementById('orderInput');
      var num = input ? input.value.trim() : '';
      var carrier = (document.getElementById('carrierSel') || {}).value;
      var help = document.getElementById('trackHelp');
      if (!num) { if (help) { help.textContent = "Please paste your tracking number first 🙂"; help.style.color = "var(--primary-deep)"; } if (input) input.focus(); return; }
      if (help) help.style.color = "";
      var n = encodeURIComponent(num);
      var urls = {
        "17track": "https://t.17track.net/en#nums=" + n,
        "auto": "https://t.17track.net/en#nums=" + n,
        "parcelsapp": "https://parcelsapp.com/en/tracking/" + n,
        "aliexpress": "https://global.cainiao.com/newDetail.htm?mailNoList=" + n
      };
      var url = urls[carrier] || urls.auto;
      document.querySelectorAll('.tstep').forEach(function (s, i) { s.classList.toggle('done', i <= 2); });
      var prog = document.getElementById('trackProgress'); if (prog) prog.style.width = (2 / 3 * 84) + "%";
      if (help) help.textContent = "Opening live tracking in a new tab — it updates on its own as your parcel moves. 🌍";
      window.open(url, "_blank", "noopener");
      toast("Live tracking opened in a new tab 📦");
    };

    /* ---------- plushie matching quiz ---------- */
    var quizQs = [
      { q: "Who's this little friend for?", sub: "So we can match the right vibe.",
        opts: [{ e: "👶", t: "A toddler", v: "toddler" }, { e: "🧒", t: "A big kid", v: "bigkid" }, { e: "🧑", t: "Me / an adult", v: "adult" }, { e: "🎁", t: "It's a gift", v: "gift" }] },
      { q: "What do they need most?", sub: "Pick the one that fits best.",
        opts: [{ e: "😴", t: "Better sleep", v: "sleep" }, { e: "🫂", t: "Comfort & calm", v: "comfort" }, { e: "😄", t: "Giggles & play", v: "play" }, { e: "✨", t: "Something cute to collect", v: "collect" }] },
      { q: "What's your budget?", sub: "No judgment — there's a friend at every price.",
        opts: [{ e: "💸", t: "Under $20", v: "low" }, { e: "💰", t: "Around $20–25", v: "mid" }, { e: "🌟", t: "Treat them ($25+)", v: "high" }, { e: "🎲", t: "Surprise me", v: "any" }] }
    ];
    var quizStep = 0, quizAns = [];
    var quizBox = document.getElementById('quizBox');
    function renderQuiz() {
      if (!quizBox) return;
      var bar = quizQs.map(function (_, i) { return '<i class="' + (i <= quizStep ? 'on' : '') + '"></i>'; }).join('');
      var cur = quizQs[quizStep];
      quizBox.innerHTML =
        '<div class="quiz-bar">' + bar + '</div>' +
        '<div class="quiz-q"><h3>' + cur.q + '</h3><p class="qsub">' + cur.sub + '</p>' +
        '<div class="quiz-opts">' +
          cur.opts.map(function (o) { return '<button class="quiz-opt" onclick="answerQuiz(\'' + o.v + '\')"><span class="qe">' + o.e + '</span>' + o.t + '</button>'; }).join('') +
        '</div>' +
        (quizStep > 0 ? '<button class="quiz-back" onclick="backQuiz()">← back</button>' : '') +
        '</div>';
    }
    window.answerQuiz = function (v) { quizAns[quizStep] = v; if (quizStep < quizQs.length - 1) { quizStep++; renderQuiz(); } else { showQuizResult(); } };
    window.backQuiz = function () { if (quizStep > 0) { quizStep--; renderQuiz(); } };
    function showQuizResult() {
      var budget = quizAns[2];
      var pool = products.slice();
      var filtered = pool.filter(function (p) {
        var pr = p.priceNum;
        if (budget === 'low') return pr <= 20;
        if (budget === 'mid') return pr >= 20 && pr <= 25;
        if (budget === 'high') return pr >= 25;
        return true;
      });
      if (!filtered.length) filtered = pool;
      var picks = filtered.slice(0, 3);
      var cards = picks.map(function (p) {
        return '<div class="qmatch"><img src="' + p.img + '" alt="' + p.name + '"><div class="qm-body"><h4>' + p.short + '</h4><div class="qm-price">' + p.priceStr + '</div><a href="' + p.url + '">Meet ' + p.short + ' →</a></div></div>';
      }).join('');
      quizBox.innerHTML =
        '<div class="quiz-result"><span class="script">we found your match!</span>' +
        '<h3>Say hello to your plushie 🧸</h3>' +
        '<div class="quiz-matches">' + cards + '</div>' +
        '<button class="quiz-back" onclick="restartQuiz()">↺ start over</button></div>';
    }
    window.restartQuiz = function () { quizStep = 0; quizAns.length = 0; renderQuiz(); };
    renderQuiz();
  }
})();
